<template>
    <span class="badge badge-outline-primary">
        <slot></slot>
    </span>
</template>

<script>
export default {

}
</script>

<style>

</style>
